import { Button, Chip, Divider, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import SyncOutlined from "@mui/icons-material/SyncOutlined";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import toast from "react-hot-toast";
import { LuTrash2 } from "react-icons/lu";
import AppModal from "../../components/AppModal";
import UploadClaimAttachmentModal from "./components/UploadClaimAttachmentModal";
import UploadClaimModal from "./UploadClaimModal";
import { FileUpload } from "@mui/icons-material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

export default function ClaimUploadList() {
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  const [showUploadAttachmentModal, setShowUploadAttachmentModal] =
    useState(false);
  const [showUploadClaimModal, setShowUploadClaimModal] = useState(false);
  const [currentUploadData, setCurrentUploadData] = useState(null);

  const getUploadClaimHistory = async () => {
    // Retrieve the token from local storage
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token.replace(/"/g, "");

    if (!token) {
      console.error("Token not found in local storage.");
      return;
    }

    try {
      setLoadingFile(true);
      const response = await axios.get(
        "https://api.supergitsa.com/api/tasks?type=excel upload",
        {
          headers: {
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        }
      );
      setLoadingFile(false);
      setUploadData(response?.data?.data);
      // Handle success response
    } catch (error) {
      setLoadingFile(false);
      console.log(error);
      toast.error(error?.response?.data?.error);
      // Handle error response
    }
  };

  useEffect(() => {
    getUploadClaimHistory();
  }, []);

  const handleprocess = async (claimRefference) => {
    // Retrieve the token from local storage
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token.replace(/"/g, "");

    if (!token) {
      console.error("Token not found in local storage.");
      return;
    }

    try {
      setLoadingFile(true);
      const response = await axios.post(
        `https://api.supergitsa.com/api/claim/excel/process?excel_id=${claimRefference}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        }
      );
      setLoadingFile(false);
      toast.success(response?.data?.message);
      // Handle success response
    } catch (error) {
      setLoadingFile(false);
      console.log(error);
      toast.error(error?.response?.data?.error);
      // Handle error response
    }
  };
  const handleDownloadClick = () => {
    const fileUrl = "/claimSample.xlsx";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "claimSample.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <div className="pre_auth_container !p-0">
        <div className="flex justify-between flex-col lg:flex-row gap-4 mb-3 px-3">
          <div className="">
            <Tooltip
              placement="right"
              title="Keep track of your upload Claims"
              className="my-auto !mt-2"
            >
              <span className="font-semibold text-black/70 text-xl ">
                Upload HISTORY
                <span className="italic text-lg ml-1">
                  ({uploadData?.length || 0}{" "}
                  <span className="text-xs font-bold italic">Entries</span>)
                </span>
              </span>
            </Tooltip>
          </div>

          <div className="flex gap-3 flex-col lg:flex-row">
            <Button
              variant="outlined"
              size="small"
              onClick={handleDownloadClick}
              disabled={loadingFile}
              className="!border-primary !text-primary hover:!bg-primary/10"
              startIcon={<FileDownloadOutlinedIcon />}
            >
              Download Sample File
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => setShowUploadClaimModal(true)}
              style={{
                backgroundImage:
                  "linear-gradient(83deg, #f14f3e 0%, #fab768 100%)",
              }}
              startIcon={<FileUpload />}
            >
              Upload Excel
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3">
          {uploadData &&
            uploadData?.map((el) => (
              <div
                key={el.Id}
                className="card shadow-md p-2 rounded-md grid grid-cols-7"
              >
                <div className="eligibility_details_user_data py-2">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Task Type</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-sm !font-semibold">
                      {el?.TaskType || "___"}
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Reference No</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-base !font-semibold">
                      {el?.ReferenceNo || "___"}
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Created at</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-base !font-semibold">
                      {new Date(el?.CreatedAt)?.toLocaleDateString() || "___"}
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Total</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-base !font-semibold">
                      {el?.Total || "0"}
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Completed</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-base !font-semibold">
                      {el?.Completed || "0"}
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Status</span>
                  </div>
                  <div className="data_cont !text-center">
                    <span className="data_cont !text-base !font-semibold">
                      <Chip
                        label={el?.IsCompleted ? "Complete" : "Incomplete"}
                        color={el?.IsCompleted ? "success" : "error"}
                        size="small"
                        className="uppercase text-xs !text-white"
                      />
                    </span>
                  </div>
                </div>

                <div className="eligibility_details_user_data py-2 ">
                  {/* <div className="data_head  !text-xs !font-semibold !text-gray-500 !text-center">
                    <span>Action</span>
                  </div> */}
                  <div className="data_cont !text-center flex gap-3 justify-end items-end">
                    <Tooltip title="Process">
                      <div
                        onClick={() => handleprocess(el?.ReferenceNo)}
                        className="text-2xl cursor-pointer"
                      >
                        <SyncOutlined />
                      </div>
                    </Tooltip>

                    <Tooltip title="Attachment">
                      <div
                        className="text-2xl cursor-pointer"
                        onClick={() => {
                          setCurrentUploadData(el);
                          setShowUploadAttachmentModal(true);
                        }}
                      >
                        <AttachmentOutlinedIcon />
                      </div>
                    </Tooltip>

                    <Tooltip title="Delete">
                      <div className="text-2xl cursor-pointer">
                        <LuTrash2 />
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <UploadClaimAttachmentModal
        showUploadAttachmentModal={showUploadAttachmentModal}
        setShowUploadAttachmentModal={setShowUploadAttachmentModal}
        currentUploadData={currentUploadData}
        setCurrentUploadData={setCurrentUploadData}
      />

      <UploadClaimModal
        showUploadClaimModal={showUploadClaimModal}
        setShowUploadClaimModal={setShowUploadClaimModal}
        getUploadClaimHistory={getUploadClaimHistory}
      />
      <AppModal isOpen={loadingFile} />
    </>
  );
}
